import './css/style.css';
import * as olProj from 'ol/proj';
import * as olSource from 'ol/source';
import * as olLayer from 'ol/layer';
import { Style, Fill, Stroke, Icon } from 'ol/style';
import { Map, View, Feature } from 'ol';
import Projection from 'ol/proj/Projection.js';
import TileLayer from 'ol/layer/Tile';
import LineString from 'ol/geom/LineString';
import Point from 'ol/geom/Point';
import OSM from 'ol/source/OSM';
import route from './data/route.json' assert { type: 'json' };
import * as olSize from 'ol/size';
import icon from './images/icon.png'

let points      = route.paths[0].points.coordinates;
let coordinates = Array(points.length);
let startDate   = new Date("2024-06-04");
let endDate     = new Date("2024-06-07T23:00:00.000Z");
let today       = new Date();
let completion  = (today - startDate) / (endDate - startDate);
let location    = Math. floor(Math.min((points.length - 1) * completion, points.length - 1));

for (var i = 0; i < coordinates.length; i++) {
    coordinates[i] = olProj.transform(points[i], 'EPSG:4326', 'EPSG:3857');
}

let to_travel = coordinates.slice(location, coordinates.length);
var toTravelLine = new Feature({ geometry: new LineString(to_travel) });

var toTravelVector = new olSource.Vector({});
toTravelVector.addFeature(toTravelLine);
var toTravelVectorLayer = new olLayer.Vector({
    source: toTravelVector,
    style: new Style({
        fill: new Fill({ color: '#FF0000', weight: 4 }),
        stroke: new Stroke({ color: '#FF0000', width: 2 })
    })
});

let travelled = coordinates.slice(0, location + 1);
var travelledLine = new Feature({ geometry: new LineString(travelled) });

var travelledVector = new olSource.Vector({});
travelledVector.addFeature(travelledLine);
var travelledVectorLayer = new olLayer.Vector({
    source: travelledVector,
    style: new Style({
        fill: new Fill({ color: '#00FF00', weight: 4 }),
        stroke: new Stroke({ color: '#00FF00', width: 2 })
    })
});

var markers = new olLayer.Vector({
  source: new olSource.Vector(),
  style: new Style({
    image: new Icon({
      src: icon,
      scale: olSize.toSize(0.3),
      anchor: [0.5, 1],
    })
  })
});

const map = new Map({
  target: 'map',
  layers: [
    new TileLayer({
      source: new OSM()
    })
  ],
  view: new View({
    center: [0, 0],
    zoom: 2
  })
});

map.addLayer(travelledVectorLayer);
map.addLayer(toTravelVectorLayer);
map.addLayer(markers);

map.setView(new View({
    center: coordinates[location],
    zoom: 15
}));

var marker = new Feature(new Point(olProj.fromLonLat(points[location])));
markers.getSource().addFeature(marker);
